import type { AxiosRequestConfig } from 'axios'

import { callAPI, laborerWpsAPIWithCredentials } from 'api/axios'
import { GeneralFailResponse, TransactionFromBE } from 'common/types/commonTypes'
import { LIST_ITEMS_PER_PAGE } from 'common/constants'

export type GetTransactionsListParams = {
  iqamaNumber: string
}

export type GetTransactionsListResponse = {
  data: Array<TransactionFromBE>
}

const getTransactionsList = ({ iqamaNumber }: GetTransactionsListParams, config?: AxiosRequestConfig) =>
  laborerWpsAPIWithCredentials.get<GetTransactionsListResponse>('api/v1.0/laborer/transactions/offline/index', {
    params: {
      iqama_number: iqamaNumber,
      per_page: 99,
    },
    ...config,
  })

export type GetTransactionDetailsParams = {
  id: string
}

export type GetTransactionDetailsResponse = {
  data: TransactionFromBE
}

const getTransactionDetails = ({ id }: GetTransactionDetailsParams, config?: AxiosRequestConfig) =>
  laborerWpsAPIWithCredentials.get<GetTransactionDetailsResponse>(
    `api/v1.0/laborer/transactions/offline/${id}`,
    config,
  )

export type AcceptSalaryPaymentParams = {
  id: number
}

const acceptSalaryPayment = ({ id }: AcceptSalaryPaymentParams, config?: AxiosRequestConfig) =>
  laborerWpsAPIWithCredentials.post<{}>(`api/v1.0/laborer/transactions/offline/${id}/approve`, config)

export type RejectSalaryPaymentParams = {
  id: number
}

const rejectSalaryPayment = ({ id }: RejectSalaryPaymentParams, config?: AxiosRequestConfig) =>
  laborerWpsAPIWithCredentials.post<{}>(`api/v1.0/laborer/transactions/offline/${id}/reject`, config)

export type GetWpsTransactionsListParams = {
  perPage?: number
  page?: number
}

export type GetWpsTransactionsListResponse = {
  data: Array<TransactionFromBE>
  meta: {
    last_page: number
  }
}

const getWpsTransactionsList = (
  { perPage = LIST_ITEMS_PER_PAGE, page = 0 }: GetWpsTransactionsListParams,
  config?: AxiosRequestConfig,
) =>
  laborerWpsAPIWithCredentials.get<GetWpsTransactionsListResponse>('api/v1.0/laborer/transactions', {
    params: {
      per_page: perPage,
      page: page + 1,
    },
    ...config,
  })

export type GetWpsTransactionInfoParams = {
  transactionId: string
}

export type GetWpsTransactionInfoResponse = TransactionFromBE

const getWpsTransactionInfo = ({ transactionId }: GetWpsTransactionInfoParams, config?: AxiosRequestConfig) =>
  laborerWpsAPIWithCredentials.get<GetWpsTransactionInfoResponse>(`api/v1.0/laborer/transactions/${transactionId}`, {
    ...config,
  })

export default {
  getTransactionsList: callAPI<typeof getTransactionsList, GetTransactionsListResponse, GeneralFailResponse>(
    getTransactionsList,
  ),
  getTransactionDetails: callAPI<typeof getTransactionDetails, GetTransactionDetailsResponse, GeneralFailResponse>(
    getTransactionDetails,
  ),
  getWpsTransactionsList: callAPI<typeof getWpsTransactionsList, GetWpsTransactionsListResponse>(
    getWpsTransactionsList,
  ),
  getWpsTransactionInfo: callAPI<typeof getWpsTransactionInfo, GetWpsTransactionInfoResponse>(getWpsTransactionInfo),
  acceptSalaryPayment: callAPI<typeof acceptSalaryPayment, {}, GeneralFailResponse>(acceptSalaryPayment),
  rejectSalaryPayment: callAPI<typeof rejectSalaryPayment, {}, GeneralFailResponse>(rejectSalaryPayment),
}
